exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-pagination {\n  padding: 15px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  background: #fff;\n}", ""]);

// exports
